import { host } from '../settings';

const hasVersionSuffix = (value: string) => /\/v\d+\/?$/.test(value);
const isAbsoluteUrl = (value: string) => /^https?:\/\//.test(value);

export const createPath = (path: string) => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;

  if (!host || isAbsoluteUrl(host.trim())) {
    return `${normalizedPath}`;
  }

  const prefix = hasVersionSuffix(host.trim()) ? '' : '/api/v1';

  return `${prefix}${normalizedPath}`;
};
